import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { SessionPrepInfo } from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';
import { mapNextSessionPostData } from 'features/sessions/utils';

export const useNextSessionUpdateMutation = (sessionId: string) => {
  const { request } = useMutationHTTPRequest();
  const queryClient = useQueryClient();

  const { updateSession } = useSessionsQueryActions();

  return useMutation(
    (session: SessionPrepInfo) =>
      request({
        url: `/api/coach/coaching-sessions/${sessionId}/update-prep-info`,
        body: mapNextSessionPostData(session),
      }),
    {
      onSuccess: (newSessionPrepInfo: SessionPrepInfo) => {
        updateSession(sessionId, {
          nextSessionAppointment: newSessionPrepInfo.nextSessionAppointment,
          nextSessionNotes: newSessionPrepInfo.nextSessionNotes,
          // Session cache uses CoachingToolNote[], prep-info returns CoachingTool[].
          // The UI pieces we use here only rely on the CoachingTool fields.
          // @ts-expect-error - compatible structural type
          nextSessionTools: newSessionPrepInfo.nextSessionTools,
        });

        queryClient.setQueryData(
          [queryKeys.coachingSessionPrepInfo, sessionId],
          newSessionPrepInfo
        );

        queryClient.invalidateQueries({
          queryKey: [queryKeys.coachingSessionPrepInsights, sessionId],
        });
      },
      onError: (e) => {
        logError(e);
      },
    }
  );
};
